import { Link, useLocation } from "react-router";
import "./navbar.scss";
import { useEffect } from "react";
import { FaHome } from "react-icons/fa";
import { HiMiniSquare3Stack3D } from "react-icons/hi2";
import { IoMdContacts } from "react-icons/io";

const Navbar = ({ navbarRef }) => {
  const location = useLocation();

  useEffect(() => {
    console.log(location.pathname);
  }, [location]);

  return (
    <div className="navbar_main" ref={navbarRef}>
      <div className="navbar_container">
        <Link
          to={"/"}
          className={`${location.pathname === "/" ? "selected" : ""}`}
        >
          <FaHome />
          HOME
        </Link>
        <Link
          to={"/projects"}
          className={`${location.pathname === "/projects" ? "selected" : ""}`}
        >
          <HiMiniSquare3Stack3D />
          PROJECTS
        </Link>
        <Link
          to={"/contact"}
          className={`${location.pathname === "/contact" ? "selected" : ""}`}
        >
          <IoMdContacts />
          CONTACT
        </Link>
      </div>
    </div>
  );
};

export default Navbar;
